"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptInLabel = exports.generatePrivacyText = void 0;
const preregistration_1 = require("./preregistration");
const LanguageTypes = ["en", "es"];
const generatePrivacyText = (config, language = "en") => {
    var _a, _b, _c, _d, _e, _f, _g;
    const stringReplacements = [
        { key: "artistName", value: config.artistName || "" },
    ];
    const separateTerms = (_d = (_c = (_b = (_a = config.fields) === null || _a === void 0 ? void 0 : _a.privacyPolicies) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.filter(({ isSeparate }) => isSeparate)) === null || _d === void 0 ? void 0 : _d.map((p) => `I agree to the <a href='${p.url}' target='_blank'>${p.name} Privacy Policy</a>.`);
    const policies = (_g = (_f = (_e = config.fields) === null || _e === void 0 ? void 0 : _e.privacyPolicies) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.filter(({ isSeparate }) => !isSeparate);
    const sms = (0, preregistration_1.updateStringVars)(smsOptIns[language], stringReplacements);
    const terms = (0, exports.getOptInLabel)(language, config.artistName || "", policies);
    return { sms, terms, separateTerms };
};
exports.generatePrivacyText = generatePrivacyText;
const smsOptIns = {
    en: "I'd like to receive text or messaging service messages from {artistName} or via {artistName}'s partners or representatives. Consent is not a condition of purchase. Message data rates may apply.",
    es: "Me gustaría recibir mensajes de texto de {artistName} o a través de los socios o representantes de {artistName}. El consentimiento no es una condición de compra. Pueden aplicar tarifas de datos de mensajes.",
};
const label = {
    privacyPolicy: {
        en: "Privacy Policy",
        es: "política de privacidad",
    },
    termsOfUse: {
        en: "Terms of Use",
        es: "términos de uso",
    },
};
const labelConjunction = {
    en: "and",
    es: "y la",
};
const linkConjunction = {
    en: "and",
    es: "y",
};
const statements = {
    statement1: {
        en: `I am at least 13 years of age and agree to share the above information with {artistName} and SET. I agree to SET's {setAgreement} as well as <a href='{artistUrl}' target='_blank'>{artistName}'s Privacy Policy</a>.`,
        es: `Soy mayor de 13 años y acepto compartir la información anterior con {artistName} y SET. Acepto los {setAgreement} de SET, así como la <a href='{artistUrl}' target='_blank'>Política de privacidad de {artistName}</a>.`,
    },
    statement2: {
        en: `I am at least 13 years of age and agree to SET's {setAgreement} as well as the privacy policies of {additionalLinks}.`,
        es: `Soy mayor de 13 años y acepto los {setAgreement} de SET, así como las políticas de privacidad de {additionalLinks}.`,
    },
    statement3: {
        en: `I am at least 13 years of age and agree to share the above information with {artistName} and SET. I agree to SET's {setAgreement} as well as the privacy policies of {additionalLinks}.`,
        es: `Soy mayor de 13 años y acepto compartir la información anterior con {artistName} y SET. Acepto los {setAgreement} de SET, así como las políticas de privacidad de {additionalLinks}.`,
    },
    statement4: {
        en: `I am at least 13 years of age and agree to share the above information with {artistName} and SET and agree to SET's {setAgreement}.`,
        es: `Soy mayor de 13 años y acepto compartir la información anterior con {artistName} y SET y acepto los {setAgreement} de SET.`,
    },
};
const setAgreement = (lang) => `<a href="#" onclick="(function(e){
  const event = new Event('setfan-show-terms', {bubbles: true});
  e.target.dispatchEvent(event);
  e.stopPropagation();
  return false;
})(arguments[0]);return false;">${label.termsOfUse[lang]}</a>
 ${labelConjunction[lang]} <a href="#" onclick="(function(e){
  const event = new Event('setfan-show-privacy', {bubbles: true});
  e.target.dispatchEvent(event);
  e.stopPropagation();
  return false;
})(arguments[0]);return false;">${label.privacyPolicy[lang]}</a>`;
const createEntityLinks = (entities, conjunction) => {
    return entities.map((entity, index) => `${!!(entities === null || entities === void 0 ? void 0 : entities.length) &&
        entities.length > 1 &&
        index === entities.length - 1
        ? `${conjunction} `
        : ""}<a href='${entity.url}' target='_blank'>${entity.name}</a>`);
};
const getOptInLabel = (lang, artistName, values) => {
    var _a;
    const firstArtistPolicyIndex = (_a = (values || [])) === null || _a === void 0 ? void 0 : _a.findIndex(({ entity }) => entity === "artist");
    const artistPolicy = firstArtistPolicyIndex >= 0 ? values === null || values === void 0 ? void 0 : values[firstArtistPolicyIndex] : undefined;
    const additionalPolicies = values === null || values === void 0 ? void 0 : values.filter((a, i) => i !== firstArtistPolicyIndex);
    const getStatement = (statement, additionalLinks) => {
        const mapObj = {
            "{setAgreement}": setAgreement(lang),
            "{artistName}": artistName,
            "{artistUrl}": (artistPolicy === null || artistPolicy === void 0 ? void 0 : artistPolicy.url) || "",
            "{additionalLinks}": additionalLinks || "",
        };
        const regex = new RegExp(Object.keys(mapObj).join("|"), "gi");
        let selectedStatement = statements[statement][lang];
        selectedStatement = selectedStatement.replace(regex, (matched) => mapObj[matched]);
        return selectedStatement;
    };
    // No policy links provided for artist or additional entities
    if (!(values === null || values === void 0 ? void 0 : values.length)) {
        return getStatement("statement4");
    }
    // artist has privacy policy link, but no additional entities present.
    if (!(additionalPolicies === null || additionalPolicies === void 0 ? void 0 : additionalPolicies.length) && (artistPolicy === null || artistPolicy === void 0 ? void 0 : artistPolicy.url)) {
        return getStatement("statement1");
    }
    // additional entities have included a privacy policy link
    const additionalLinks = createEntityLinks(values, linkConjunction[lang]);
    // more than 2 entities
    if (values.length > 2) {
        return getStatement("statement2", additionalLinks.join(", "));
    }
    // 1 or 2 entities
    return getStatement("statement3", additionalLinks.join(" "));
};
exports.getOptInLabel = getOptInLabel;
//# sourceMappingURL=privacy.js.map